<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title">Article List</h4>
          <div class="md-card-header-icon md-card-header-green text-right">
            <md-button
              v-if="$store.role === 1 || $store.role === 4"
              @click="goToCreate"
              class="md-success"
              >CREATE ARTICLE</md-button
            >
          </div>
        </md-card-header>
        <md-card-content>
          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">Per page</label>
                <md-select
                  v-model="pagination.perPage"
                  name="pages"
                  @md-selected="customSort"
                >
                  <md-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>

              <div>
                <md-button
                  style="margin-left: 10px"
                  @click="filterPanel"
                  class="md-info"
                >
                  Filters
                </md-button>
                <md-button
                  style="margin-left: 10px"
                  @click="clearFilters"
                  class="md-primary md-just-icon md-round"
                >
                  <md-icon>delete_sweep</md-icon>
                  <md-tooltip md-direction="bottom">Clear Filters</md-tooltip>
                </md-button>
              </div>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Title" md-sort-by="title">{{
                item.title
              }}</md-table-cell>
              <md-table-cell md-label="Short Info">{{
                item.short_info
              }}</md-table-cell>
              <md-table-cell md-label="Is Public?">{{
                item.is_public
              }}</md-table-cell>
              <md-table-cell md-label="Created Date">{{
                item.created_date
              }}</md-table-cell>
              <md-table-cell md-label="Modified Date">{{
                item.modified_date
              }}</md-table-cell>
              <md-table-cell md-label="Actions">
                <md-button
                  style="margin-right: 14px;"
                  class="md-just-icon md-warning md-round"
                  @click.native="handleEdit(item)"
                >
                  <md-icon>create</md-icon>
                  <md-tooltip md-direction="bottom">Edit</md-tooltip>
                </md-button>
                <md-button
                  style="margin-right: 10px;"
                  class="md-just-icon md-danger md-round mg-10"
                  @click.native="handleDelete(item)"
                >
                  <md-icon>close</md-icon>
                  <md-tooltip md-direction="bottom">Delete</md-tooltip>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-content class="md-size-50 mx-auto" v-if="table_spinner">
          <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class="">
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
            @page="updatePage"
          >
          </pagination>
        </md-card-actions>
      </md-card>
      <md-dialog :md-active.sync="showFilters" class="filterPanelClass">
        <md-dialog-title>Filters</md-dialog-title>

        <div class="md-layout-item md-size-100 md-small-size-100">
          <md-field>
            <md-icon>account_balance</md-icon>
            <label>Title</label>
            <md-input v-model="title" type="text"></md-input>
          </md-field>
        </div>

        <div class="md-layout-item md-size-100 md-small-size-100">
          <md-datepicker v-model="created_date" md-immediately>
            <label>Created Date</label>
          </md-datepicker>
        </div>
        <div class="md-layout-item md-size-100 md-small-size-100">
          <md-datepicker v-model="modified_date" md-immediately>
            <label>Modified Date</label>
          </md-datepicker>
        </div>

        <md-dialog-actions>
          <md-button class="md-danger" @click="showFilters = false"
            >Close</md-button
          >
          <md-button class="md-success" @click="addFilter">Filter</md-button>
        </md-dialog-actions>
      </md-dialog>
    </div>
  </div>
</template>

<script>
import { Pagination } from "@/components";
import Swal from "sweetalert2";

export default {
  components: {
    Pagination
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      return this.tableData;
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.total;
    },
    getParams() {
      return {
        ordering: this.getSortingKey(),
        limit: this.pagination.perPage,
        offset: this.from,
        ...this.searchQuery
      };
    }
  },
  data() {
    return {
      currentSort: "id",
      currentSortOrder: "desc",
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [10, 20, 30],
        total: 0
      },
      searchQuery: {},
      propsToSearch: [
        "id",
        "title",
        "created_date",
        "modified_date"
      ],
      tableData: [],
      searchedData: [],
      first: true,

      table_spinner: true,
      showFilters: false,

      title: null,
      created_date: null,
      modified_date: null
    };
  },
  methods: {
    goToCreate: function() {
      this.$router.push({ name: "Article Create" });
    },
    filterPanel: function() {
      this.showFilters = true;
    },
    clearFilters: function() {
      this.searchQuery = {};
      this.title = null;
      this.created_date = null;
      this.modified_date = null;
      this.pagination.currentPage = 1;
      this.getArticles();
    },
    addFilter: function() {
      let origin_params = {};
      let params = {
        title: this.title,
        created_date: this.created_date,
        modified_date: this.modified_date
      };
      for (const field in params) {
        if (
          params[field] === null ||
          params[field] === undefined ||
          params[field] === ""
        ) {
          continue;
        }
        origin_params[field] = params[field];
      }
      this.searchQuery = origin_params;
      this.pagination.currentPage = 1;
      this.getArticles();
      this.showFilters = false;
    },
    customSort(value) {
      if (this.first) {
        this.first = false;
        this.checkQueryParam();
      } else {
        this.pagination.currentPage = 1;
      }
      this.getArticles();
    },
    getSortingKey() {
      var key = this.currentSort;
      if (this.currentSortOrder === "desc") {
        key = "-" + this.currentSort;
      }
      return key;
    },
    handleEdit(item) {
      this.$router.push({
        name: "Article Update",
        params: { id: item.id }
      });
    },
    handleDelete(item) {
      Swal.fire({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store
            .deleteArticle(item.id)
            .then(response => {
              this.deleteRow(item);
              this.$notify({
                message: "Deleted!",
                icon: "add_alert",
                type: "warning",
                verticalAlign: "top"
              });
            })
            .catch(error => {
              this.$notify({
                message: JSON.stringify(error.response.data),
                icon: "add_alert",
                type: "warning",
                verticalAlign: "top"
              });
            });
        }
      });
    },
    deleteRow(item) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === item.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    getArticles() {
      this.tableData = [];
      this.table_spinner = true;
      var params = this.getParams;
      this.$store
        .getArticles(params)
        .then(response => {
          this.tableData = response.data.results;
          this.pagination.total = response.data.count;
          if (params.offset) {
            this.pagination.currentPage = this.getCurrentPage(params.offset);
          }
          this.table_spinner = false;
        })
        .catch(error => {
          this.table_spinner = false;
          this.$notify({
            message: JSON.stringify(error.response.data),
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top"
          });
        });
    },
    updatePage(page) {
      this.getArticles();
    },
    getCurrentPage(offset) {
      return offset / this.pagination.perPage + 1;
    },
    checkQueryParam() {
      if (window.location.search !== "") {
        var params = window.location.search
          .slice(1)
          .split("&")
          .map(p => p.split("="))
          .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (params.ordering) {
          if (params.ordering[0] === "-") {
            this.currentSortOrder = "desc";
            params.ordering = params.ordering.replace("-", "");
          } else {
            this.currentSortOrder = "asc";
          }
          this.currentSort = params.ordering;
          delete params.ordering;
        }
        if (params.limit) {
          this.pagination.perPage = parseInt(params.limit);
          delete params.limit;
        }
        if (params.offset) {
          this.pagination.currentPage = this.getCurrentPage(params.offset);
          delete params.offset;
        }
        this.searchQuery = params;
      }
    }
  },
  watch: {
    searchQuery(query) {
      let params = this.getParams;
      let query_param = Object.keys(params)
        .map(key => key + "=" + params[key])
        .join("&");
      window.history.replaceState(
        "page",
        "Title",
        window.location.pathname + "?" + query_param
      );
    },
    pagination: {
      deep: true,
      handler(val) {
        let params = this.getParams;
        let query_param = Object.keys(params)
          .map(key => key + "=" + params[key])
          .join("&");
        window.history.replaceState(
          "page",
          "Title",
          window.location.pathname + "?" + query_param
        );
      }
    }
  }
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
